import { useState, useEffect } from "react";
import LandingPage from "../../comp/LandingPage/LandingPage";
import Statics from "../../comp/Statics/Statics";
import './Home.css'
import CustomiseWeb from "../../comp/CustomiseWeb/CustomiseWeb";
import Listbox from "../../comp/Listbox/Listbox";
import ProjectGallery from "../../comp/ProjectGallery/ProjectGallery";
import Popular from "../../comp/PopularServices/Popular";
import NewsLetter from "../../comp/NewsLetter/NewsLetter";
import Reviews from "../../comp/Reviews/Reviews";
import { useLocation, useNavigate } from 'react-router-dom';
import Technology from "../../comp/Technology/Technology";

import {
  HomeLanding,
  React,
  Angular,
  Android,
  IOS,
  Flutter,
  Salesforce,
  Html,
  Css,
  JavaScript,
  Java,
  Node,
  Php,
  Laravel,
  Codeigniter,

  On_time_delivery,
  Industry_Expertise,
  Agile_Delivery,
  Impeccable_quality,
  Aviation_messaging,
  Consumer_Products,
  Financial_Services,
  Industrial_Services,
  Media,
  Mining_Construction,
  Private_Equity,
  Retail,
  Social_Sector,
  Technology_S,
  Telecommunications,
  Utilities_Energy,
  Logistics_Automotive,
  E_learning,
} from '../../assests/images';

export default function HomePage({ setActive, title }) {
  const location = useLocation();
  const navigate = useNavigate();
  const { state } = location;
  // State to track whether scrolling has occurred
  const [hasScrolled, setHasScrolled] = useState(false);
  useEffect(() => {
    if (!hasScrolled && state?.scrolling) {
      const scroll = state.scrolling;
      const servicesElement = document.getElementById(scroll);

      if (servicesElement) {
        // Scroll into view
        servicesElement.scrollIntoView({ behavior: 'smooth' });
        setHasScrolled(true);
        navigate(location.pathname, { state: null, replace: true });
      }
    }
  }, [location.state, hasScrolled, navigate]);


  useEffect(function () {
    document.title = title;
    setActive('Home')
  }, [setActive, title])

  const strangthsData = [
    {
      icon: On_time_delivery,
      heading: "On-time delivery"
    },
    {
      icon: Industry_Expertise,
      heading: "Industry Expertise",
    },
    {
      icon: Agile_Delivery,
      heading: "Agile Delivery",
    },

    {
      icon: Impeccable_quality,
      heading: "Impeccable quality",
    },

  ]

  const IndustriesData = [
    {
      icon: Aviation_messaging,
      heading: "Aviation messaging",
    },
    {
      icon: Consumer_Products,
      heading: "Consumer Products",
    },
    {
      icon: Financial_Services,
      heading: "Financial Services",
    },

    {
      icon: Industrial_Services,
      heading: "Industrial Goods and Services",
    },
    {
      icon: Media,
      heading: "Media",
    },
    {
      icon: Mining_Construction,
      heading: "Mining and Construction",
    },
    {
      icon: Private_Equity,
      heading: "Private Equity",
    },
    {
      icon: Retail,
      heading: "Retail",
    },
    {
      icon: Social_Sector,
      heading: "Social and Public Sector",
    },
    {
      icon: Technology_S,
      heading: "Technology",
    },
    {
      icon: Telecommunications,
      heading: "Telecommunications",
    },
    {
      icon: Utilities_Energy,
      heading: "Utilities and Alternative Energy",
    },
    {
      icon: Logistics_Automotive,
      heading: "Logistics and Automotive",
    },
    {
      icon: E_learning,
      heading: "E-learning"
    },
  ]


  const data = [
    { 'img': React, 'text': 'React' },
    { 'img': Angular, 'text': 'Angular.' },
    { 'img': Android, 'text': 'Android' },
    { 'img': IOS, 'text': 'IOS' },
    { 'img': Flutter, 'text': 'Flutter' },
    { 'img': Salesforce, 'text': 'Salesforce' },
    { 'img': Html, 'text': 'HTML' },
    { 'img': Css, 'text': 'CSS' },
    { 'img': JavaScript, 'text': 'JavaScript' },
    { 'img': React, 'text': 'React Native' },
    { 'img': Node, 'text': 'Node' },
    { 'img': Java, 'text': 'JAVA' },
    { 'img': Php, 'text': 'PHP' },
    { 'img': Laravel, 'text': 'Laravel' },
    { 'img': Codeigniter, 'text': 'Codeigniter' },

  ]

  return (
    <div className="home__container">

      <LandingPage img={HomeLanding} subhead={"Create. Transform. Evolve"} subheading={<>Gravit Infosystem believes in <strong>"delivering intelligence"</strong> to businesses to transform their technological outlook by expanding their software through our high-quality business process and technology consulting services backed by our essential expertise. </>}
        heading={'Unleash the Potential of Technology'} headingType={'text'} buttonText={'OUR SERVICES'} scroll={"services"} />
      <Technology
        data={data}
        heading={"TECHNOLOGY WE EXCEL"}
      />
      <>
        <Listbox />
        <CustomiseWeb
          heading={"Our Strengths"}
          data={strangthsData}
        />
      </>

      <Statics />

      <Popular />
      {/* <ProjectGallery /> */}
      <CustomiseWeb
        heading={"Industries we serve"}
        data={IndustriesData}
      />
      <Reviews />

      {/* <NewsLetter /> */}

    </div>
  )
}

